import { render } from "./ProjectRelatedProjects.vue?vue&type=template&id=a4218608&scoped=true"
import script from "./ProjectRelatedProjects.vue?vue&type=script&lang=js"
export * from "./ProjectRelatedProjects.vue?vue&type=script&lang=js"

import "./ProjectRelatedProjects.vue?vue&type=style&index=0&id=a4218608&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4218608"]])

export default __exports__